package com.essntl.features.dashboard.ui.components.taskcard

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.dashboard.ui.DashboardState
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberFind
import com.essntl.uikit.theme.esTypography

@Composable
fun ServiceTask(
    state: DashboardState,
    task: TaskModel,
) {
    val category = rememberFind(
        state.getAllCategory.data.orEmpty(),
        task.itineraryService?.service?.category,
    ) { category -> category.id }

    Row {
        AsyncUrlIcon(
            url = category?.iconUrl ?: "",
            contentDescription = category?.name,
            tint = Color(0xFF8985A2),
            modifier = Modifier.size(20.dp),
        )

        Spacer(modifier = Modifier.width(1.spacing))

        Text(
            text = task.itineraryService?.service?.title ?: "service name",
            style = MaterialTheme.esTypography.p2Medium14,
            overflow = TextOverflow.Ellipsis,
        )
    }
}